import _ from "lodash";

import { HeaderPositionType, ListStyleType, TextStyleType } from "../constants";
import { BaseCategory } from "./BaseCategory";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class SourcesListCategory extends BaseCategory {
    get name() {
        return "List";
    }

    get type() {
        return SlideCategories.SOURCES_LIST;
    }

    get icon() {
        return null;
    }

    get description() {
        return "The userinput contains a list of sources used to create the presentation.";
    }

    get slideTypes() {
        return [];
    }

    getPromptResult(request) {
        return {
            slideTitle: "Sources list",
            slideSubTitle: "Sources used to create the presentation",
            userInputAnalysis: {
                hasTitle: true,
                hasVisual: false,
                hasConclusion: false
            },
            slide: {
                sources: request.sources
            }
        };
    }

    getSlideModels(model, options = {}) {
        return [this.buildBulletPointSlide(model, null, options)];
    }

    buildBulletPointSlide(model, trayOptions, options = {}) {
        let builder = new SlideModelBuilder("textlist", model, true);
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        let listStyle = ListStyleType.BULLET;

        let titleCounts = {};
        let sources = _.cloneDeep(model.sources ?? []);
        sources = _.sortBy(sources, "title");
        sources.forEach(source => {
            titleCounts[source.title] = (titleCounts[source.title] || 0) + 1;
            if (titleCounts[source.title] > 1) {
                source.title = `${source.title} (${titleCounts[source.title]})`;
            }
        });

        if (sources.length === 0) {
            builder.createPrimary({
                collectionColor: "theme",
                listStyle,
                items: [{
                    isMedia: false,
                    text: {
                        blocks: [
                            builder.createBlock("No external sources were used to create this presentation.", TextStyleType.BULLET_LIST, { listStyle, bulletColor: null, indent: 0 })
                        ]
                    }
                }]
            });

            return builder.model;
        }

        let cols = 1;
        if (sources.length > 4 || !trayOptions) {
            cols = 2;
        }
        if (sources.length > 6) {
            cols = 3;
            trayOptions = null; // remove image for very long lists
        }
        const itemsInCol = Math.ceil(sources.length / cols);

        let col = {
            isMedia: false,
            text: {
                blocks: []
            }
        };
        const items = [col];
        for (let i = 0; i < sources.length; i++) {
            if (i >= itemsInCol && items.length < cols) {
                col = {
                    isMedia: false,
                    text: {
                        blocks: []
                    }
                };
                items.push(col);
            }
            col.text.blocks.push(builder.createBlock(`<a href="${sources[i].url}" target="_blank" rel="noopener noreferrer">${sources[i].title}</a>`, TextStyleType.BULLET_LIST, { listStyle, bulletColor: null, indent: 0 }));
            col.text.blocks = col.text.blocks.filter(b => b);
        }

        builder.createPrimary({
            collectionColor: "theme",
            listStyle,
            items
        });

        return builder.model;
    }
}

